import { render, staticRenderFns } from "./Estimation_Details.vue?vue&type=template&id=bdea66e6&scoped=true&"
import script from "./Estimation_Details.vue?vue&type=script&lang=js&"
export * from "./Estimation_Details.vue?vue&type=script&lang=js&"
import style0 from "./Estimation_Details.vue?vue&type=style&index=0&id=bdea66e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdea66e6",
  null
  
)

export default component.exports